<template>
    <div class="tasks-list-wrapper step_3">
        <h1>{{$t('tests.wizard.testers_step.headline')}}</h1>
        <!--Tips-->
        <div class="tips_wrapper d-flex align-items-start">
            <em class="icon-infobox"></em>
            <div class="tips_content">
                <strong class="tips_title">{{$t('tests.wizard.testers_step.tips_title')}}</strong>
                <p>{{$t('tests.wizard.testers_step.tips_short_text')}}</p>
                <b-collapse id="more_tips">
                    {{$t('tests.wizard.testers_step.tips_long_text')}}
                </b-collapse>
                <b-link href="javascript:;" v-b-toggle.more_tips>{{$t('tests.wizard.testers_step.read_more')}}</b-link>
            </div>
        </div>
        <h2>{{$t('tests.wizard.testers_step.form_headline')}}</h2>
        <div class="testers_form">
            <!--Form-->
            <div class="col-tester-8">
                <b-form-group
                        :label="$t('tests.wizard.testers_step.language_country_label')"
                        label-for="language_countries_id"
                        :invalid-feedback="$parent.errors.language_countries_id"
                        :state="$parent.errors.language_countries_id ? false : null">
                    <div class="b-select-holder">
                        <b-form-select trim id="language_countries_id" text-field="label"
                                       v-model="$parent.test.language_countries_id"
                                       :state="$parent.errors.language_countries_id ? false : null"
                        >
                            <option v-for="(language, key) in countryLanguageOptions" :key="key" :value="language.id">
                                {{ language.label }}
                            </option>
                        </b-form-select>
                        <b-form-group class="option">
                            <b-link href="javascript:;" class="select-opener"
                                    v-bind:class="{'filled': $parent.test.language_countries_id}"
                                    v-b-toggle.language_countries_id>
                                <span v-if="!$parent.test.language_countries_id"
                                      v-html="$t('tests.wizard.testers_step.select_default')"></span>
                                <em class="icon-chevron-down"></em>
                            </b-link>
                            <b-collapse id="language_countries_id">
                                <b-form-radio-group
                                        plain
                                        stacked
                                        name="language_countries_id"
                                        aria-controls="language_countries_id"
                                        v-model="$parent.test.language_countries_id"
                                >
                                    <template v-for="(option, key) in countryLanguageOptions">
                                        <b-form-radio :value="option.id" :key="key">
                                            <span v-b-toggle.language_countries_id>{{ option.label }}</span>
                                        </b-form-radio>
                                    </template>
                                </b-form-radio-group>
                            </b-collapse>
                        </b-form-group>
                    </div>
                </b-form-group>
            </div>
        </div>
        <div class="testers_form" v-if="predefinedTestersPanelOptions && predefinedTestersPanelOptions.length > 0">
            <div class="col-tester-8">
                <b-form-group
                        :label="$t('tests.wizard.testers_step.predefined_panel_label')"
                        label-for="age"
                        :invalid-feedback="$parent.errors.predefined_panel_id"
                        :state="$parent.errors.predefined_panel_id ? false : null">
                    <div class="b-select-holder">
                        <b-form-select id="panel" :options="predefinedTestersPanelOptions"
                                       :text-field="'title.' + $root.lang" value-field="id"
                                       v-model="$parent.test.predefined_panel_id"
                                       :state="$parent.errors.predefined_panel_id ? false : null" trim></b-form-select>
                        <b-form-group class="option">
                            <b-link href="javascript:;" class="select-opener"
                                    v-bind:class="{'filled': $parent.test.predefined_panel_id}" v-b-toggle.panel>
                                <span v-if="!$parent.test.predefined_panel_id"
                                      v-html="$t('tests.wizard.testers_step.select_default')"></span>
                                <em class="icon-chevron-down"></em>
                            </b-link>
                            <b-collapse id="panel">
                                <b-form-radio-group
                                        v-model="$parent.test.predefined_panel_id"
                                        plain
                                        stacked
                                        name="panel"
                                >
                                    <b-form-radio :value="null" :key="'no-panel'">
                                        <span v-b-toggle.panel>{{$t('tests.wizard.testers_step.no_panel_option') }}</span>
                                    </b-form-radio>
                                    <template v-for="option in predefinedTestersPanelOptions">
                                        <b-form-radio :value="option.id" :key="option.id">
                                            <span v-b-toggle.panel>{{ option.title[$root.lang] }}</span>
                                        </b-form-radio>
                                    </template>
                                </b-form-radio-group>
                            </b-collapse>
                        </b-form-group>
                    </div>
                </b-form-group>
            </div>
        </div>
        <div v-if="!$parent.test.predefined_panel_id">
            <span class="testers-selection-else" v-html="$t('tests.wizard.testers_step.customize_pool')"></span>
            <tests-wizard-modal :rawRequirements="audienceRequirements"
                                :testSelectedAttributes="$parent.test.eligibility_requirement_attributes"
                                v-model="$parent.test.eligibility_requirement_attributes"></tests-wizard-modal>

        </div>

        <!--Participants Count-->
        <div class="testers_form">
            <div class="col-tester-8">
                <div class="tips_wrapper d-flex align-items-start"
                     v-if="!_.isNull(participantsCount) || areParticipantsCounting">
                    <em class="icon-infobox"></em>
                    <div class="tips_content">
                        <strong class="tips_title">{{$t('requirements.summary_title')}}</strong>
                        <b-spinner v-if="areParticipantsCounting"></b-spinner>
                        <p v-else
                           v-html="$t('requirements.summary_text', {count: participantsCount.toLocaleString()})"></p>
                    </div>
                </div>
            </div>
        </div>

        <!--Packages-->
        <h2>{{$t('tests.wizard.testers_step.packages_headline')}}</h2>
        <b-row class="testers_packages">
            <div class="col-tester-3" v-for="packageItem in testersPackagesOptions" :key="packageItem.id">
                <div class="testers_package_item"
                     :class="{selected: $parent.test.package_id === packageItem.id}">
                    <img class="icon-testers-image" alt="icon" :src="packageItem.image_url"
                         v-if="packageItem.image_url"/>
                    <em v-else v-bind:class="getPackageIconClass(packageItem)"></em>
                    <h4>{{ packageItem.title[$root.lang] }}</h4>
                    <strong class="testers_package_price">
                        <span class="testers_package_price_currency">{{$root.currencyLabel}}</span>
                        {{packageItem.price | price}}
                    </strong>
                    <ul>
                        <li>{{$t('tests.wizard.testers_step.package_size', {size: packageItem.testers})}}</li>
                        <li>{{$t('tests.wizard.testers_step.package_turnaround_time', {time:
                            packageItem.turnaround_time[$root.lang]})}}
                        </li>
                    </ul>
                    <p class="testers_package_description text-center">{{ packageItem.description[$root.lang]
                        }}</p>
                    <div class="testers_package_button_wrapper">
                        <b-button variant="outline-danger" size="sm" :disabled="true"
                                  v-if="participantsCount < packageItem.testers && !areParticipantsCounting">
                            <span>{{$t('tests.wizard.testers_step.not_enough_participants')}}</span>
                        </b-button>
                        <b-button variant="small-transparent" @click="selectPackage(packageItem)" v-else
                                  v-bind:class="{'active': ($parent.test.package_id === packageItem.id)}">
                            <span v-if="$parent.test.package_id === packageItem.id">{{$t('tests.wizard.testers_step.selected')}}</span>
                            <span v-else>{{$t('tests.wizard.testers_step.select')}}</span>
                        </b-button>
                    </div>
                </div>
            </div>
        </b-row>
        <tests-wizard-buttons-block :next="$parent.updateTest" :previous="$parent.previousStep"
                                    :isButtonDisabled="isButtonDisabled"></tests-wizard-buttons-block>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'tests-wizard-testers-step',
        created() {
            this.$store.dispatch('options/loadTesterStepOptions');
            this.$store.dispatch('options/loadParticipantsCount', {
                attributes: this.$parent.test.eligibility_requirement_attributes,
                predefined_panel_id: this.$parent.test.predefined_panel_id
            });
        },
        watch: {
            testersPackagesOptions: {
                handler() {
                    gtag('event', 'view_item_list', {
                        "items": _.map(this.testersPackagesOptions, packageItem => {
                            return {
                                'id': packageItem.id,
                                'name': packageItem.title.en,
                                'list_name': 'Packages List',
                                'quantity': 1,
                                'price': packageItem.price
                            }
                        })
                    });
                }
            },
            '$parent.test.eligibility_requirement_attributes': {
                handler() {
                    this.$store.dispatch('options/loadParticipantsCount', {
                        attributes: this.$parent.test.eligibility_requirement_attributes,
                        predefined_panel_id: this.$parent.test.predefined_panel_id
                    });
                },
                deep: true
            },
            '$parent.test.predefined_panel_id': {
                handler() {
                    this.$store.dispatch('options/loadParticipantsCount', {
                        attributes: this.$parent.test.eligibility_requirement_attributes,
                        predefined_panel_id: this.$parent.test.predefined_panel_id
                    });
                }
            },
            participantsCount: {
                handler() {
                    const selectedPackage = _.find(this.testersPackagesOptions, pack => pack.id === this.$parent.test.package_id);
                    if (!selectedPackage) {
                        // [Nick] Nothing to do, no package selected
                        return;
                    }
                    if (!this.participantsCount || selectedPackage.testers > this.participantsCount) {
                        this.$parent.test.package_id = null;
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ageOptions: 'options/ageOptions',
                countryLanguageOptions: 'options/countryLanguageOptions',
                predefinedTestersPanelOptions: 'options/predefinedTestersPanelOptions',
                testersPackagesOptions: 'options/testersPackagesOptions',
                audienceRequirements: 'options/audienceRequirements',
                participantsCount: 'options/participantsCount',
                areParticipantsCounting: 'options/areParticipantsCounting',
            }),

            isButtonDisabled() {
                return !((this.participantsCount > 0 && this.$parent.test.package_id) && this.$parent.test.language_countries_id)
                    && !this.$parent.test.own_testers;
            }
        },
        methods: {
            selectPackage(packageItem) {
                if (this.$parent.test.package_id === packageItem.id) {
                    this.$parent.test.package_id = null;
                    return;
                }
                this.$parent.test.package_id = packageItem.id;
                gtag('event', 'select_content', {
                    'content_type': 'product',
                    'items': [
                        {
                            'id': packageItem.id,
                            'name': packageItem.title.en,
                            'list_name': 'Packages List',
                            'quantity': 1,
                            'price': packageItem.price
                        }
                    ]
                });
            },
            getPackageIconClass(packageItem) {
                switch (packageItem.testers) {
                    case 10:
                        return 'icon-testers-1';
                    case 20:
                        return 'icon-testers-2';
                    case 30:
                        return 'icon-testers-3';
                    default:
                        return 'icon-testers-1';
                }
            }
        }
    }
</script>

<style scoped>

</style>
